module.exports = __webpack_public_path__ + "img/hx-kcgl-w.ec4014a9.svg";